import React, { Component } from 'react';
import classNames from 'classnames';
import ViewMainMarketBtn from 'containers/ViewMainMarketBtn';
import ViewOUButtons from 'containers/ViewOUButtons';
import 'css/ViewMainMarkets.scss';
import { GAMES_WITH_1X2, SPORTS } from 'constants/appConfig';
import { isMarketOverUnder } from 'utils/Helper';
import { detectMobile } from 'utils/UiHelper';

export default class ViewMainMarkets extends Component {
    buttonsRow(marketSet, className, market) {
        return (
            <div className="view-main-markets row">
                {marketSet['2'] || (!marketSet['2'] && marketSet['X']) ? (
                    <ViewMainMarketBtn
                        disabled={this.props.disabled}
                        className={className}
                        item={marketSet['1']}
                        market={market}
                        live={this.props.live}
                        ev={this.props.ev}
                    />
                ) : null}
                {marketSet['X'] ? (
                    <ViewMainMarketBtn
                        disabled={this.props.disabled}
                        className={className}
                        item={marketSet['X']}
                        market={market}
                        live={this.props.live}
                        ev={this.props.ev}
                    />
                ) : null}
                {!marketSet['X'] && !marketSet['2'] ? (
                    <ViewMainMarketBtn
                        disabled={this.props.disabled}
                        className={className}
                        item={false}
                        market={market}
                        live={this.props.live}
                        ev={this.props.ev}
                    />
                ) : null}
                <ViewMainMarketBtn
                    disabled={this.props.disabled}
                    className={className}
                    item={marketSet['2']}
                    market={market}
                    live={this.props.live}
                    ev={this.props.ev}
                />
            </div>
        );
    }
    render() {
        const market = this.props.market;
        const items = market && market.itemList ? market.itemList : [];
        /**
         * @type EventModel ev
         */
        const ev = this.props.ev;

        const marketSet = {
            1: false,
            X: false,
            2: false,
        };

        if (GAMES_WITH_1X2.includes(ev.sportId)) {
            marketSet['X'] = true;
            marketSet['1'] = true;
            marketSet['2'] = true;
        } else {
            marketSet['1'] = true;
            marketSet['2'] = true;
        }
        for (let item of items) {
            if (item?.odds > 1) {
                marketSet[item.bet] = item;
                if (item?.bet?.toLowerCase() === 'uafgjort') {
                    marketSet['X'] = item;
                }
            }
        }

        const className = '';

        const [marketOU] = (ev.marketList?.[0] &&
            ev.marketList.filter(isMarketOverUnder)) || [null];

        if (detectMobile()) {
            return this.buttonsRow(marketSet, className, market);
        } else {
            return (
                <div className="row">
                    <div
                        className={classNames({
                            'col-55': ev.sportId === SPORTS.FOOTBALL,
                        })}
                    >
                        {this.buttonsRow(marketSet, className, market)}
                    </div>
                    {ev.sportId === SPORTS.FOOTBALL && (
                        <div className="col-05">&nbsp;</div>
                    )}
                    {ev.sportId === SPORTS.FOOTBALL && (
                        <div className="col-4">
                            <ViewOUButtons ev={ev} market={marketOU} />
                        </div>
                    )}
                </div>
            );
        }
    }
}
